import React, { useEffect, useState } from "react";
import { NavLink, Link } from "react-router-dom";
import StudentDas1 from "../../../assets/StudentDas1.png";
import StudentDas2 from "../../../assets/StudentDas2.png";
import StudentDas3 from "../../../assets/StudentDas3.png";
import StudentCard from "./StudentCard";
import { getHitID } from "../../../config/HitIDStorage";
import axios from "axios";
import apiKey from "../../../config/apiKey";
import { useTranslation } from "react-i18next";

const StudentDash = () => {
  const { t } = useTranslation();
  const ID = getHitID();
  const admin = JSON.parse(localStorage.getItem("edo-admin"));

  const [totalCount, setTotalCount] = useState(0);
  const [uniqueTeacherCount, setUniqueTeacherCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!ID) return;
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
          `${apiKey}/api/edolutions/admin/readnotificationsall/${ID}`,
          { headers: { Authorization: `Bearer ${admin?.token}` } }
        );
        const notifications = res.data?.data || [];
        setTotalCount(notifications.length);
        const uniqueTeacherIds = new Set();
        notifications.forEach((n) => n?.teacher_id && uniqueTeacherIds.add(n.teacher_id));
        setUniqueTeacherCount(uniqueTeacherIds.size);
      } catch (e) {
        console.error("Error fetching data:", e);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [ID, admin?.token]);

  // Metric Card (reusable)
  const StatCard = ({ icon, label, value }) => (
    <div className="min-w-[260px] flex items-center gap-4 rounded-2xl p-4 bg-white border shadow-sm">
      <div className="shrink-0 grid place-items-center w-14 h-14 rounded-xl bg-gradient-to-br from-[#EE5F2B]/15 to-[#2A3A54]/15">
        <img src={icon} alt="" className="w-8 h-8 object-contain" />
      </div>
      <div>
        <p className="text-xs uppercase tracking-wide text-[#6B7280]">{label}</p>
        <p className="text-3xl font-semibold text-[#111827]">{value}</p>
      </div>
    </div>
  );

  // Page loader
  const PageLoader = () => (
    <div className="py-16 grid place-items-center">
      <div className="w-12 h-12 border-4 border-gray-200 border-t-[#EE5F2B] rounded-full animate-spin" />
      <p className="mt-3 text-sm font-semibold text-[#EE5F2B]">{t("adminDash.common.loading")}</p>
    </div>
  );

  return (
    <div>
      <div className="flex items-center xl:p-5 sm:p-0 justify-center">
        <div className="w-full border rounded-3xl shadow-xl p-5 bg-white">
          {/* Profile / header card */}
          <StudentCard />

          {/* Tabs */}
          <div className="flex flex-wrap md:justify-start px-4 gap-5 border-b text-base font-medium">
            <NavLink
              to="../menteeDash"
              className={({ isActive }) =>
                isActive
                  ? "text-[#EE5F2B] border-b-2 border-[#EE5F2B] pb-1"
                  : undefined
              }
            >
              {t("adminDash.findTeacher.dashboard")}
            </NavLink>

            <NavLink
              to=".././mentee-tution"
              className={({ isActive }) =>
                isActive
                  ? "text-[#EE5F2B] border-b-2 border-[#EE5F2B] pb-1"
                  : undefined
              }
            >
              {t("adminDash.studentDash.sessions")}
            </NavLink>

            <NavLink
              to=".././mentee-chat"
              className={({ isActive }) =>
                isActive
                  ? "text-[#EE5F2B] border-b-2 border-[#EE5F2B] pb-1"
                  : undefined
              }
            >
              {t("adminDash.messages")}
            </NavLink>
          </div>

          {/* Header strip */}
          <div className="mt-5 px-5">
            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-3">
              <p className="text-2xl font-bold">
                {t("adminDash.findTeacher.dashboard")}{" "}
                <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54]">
                  {t("adminDash.studentDash.overview")}
                </span>
              </p>

              {/* <div className="flex items-center gap-2">
                <Link
                  to="../mentee-tution"
                  className="px-4 py-2 rounded-xl text-white text-sm font-semibold bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54] hover:from-[#2A3A54] hover:to-[#EE5F2B]"
                >
                  Find New Mentor
                </Link>
                <Link
                  to="../mentee-chat"
                  className="px-4 py-2 rounded-xl text-[#2A3A54] border border-[#2A3A54]/30 text-sm font-semibold hover:bg-[#2A3A54]/5"
                >
                  Open Messages
                </Link>
              </div> */}
            </div>
          </div>

          {/* Stats row (non-wrapping, scrolls on small screens) */}
          <div className="mt-6">
            {loading ? (
              <PageLoader />
            ) : (
              <div className="overflow-x-auto">
                <div className="flex gap-4 min-w-[860px] px-5">
                  <StatCard
                    icon={StudentDas1}
                    label={t("adminDash.studentDash.enrolledSessions")}
                    value={totalCount}
                  />
                  <StatCard
                    icon={StudentDas2}
                    label={t("adminDash.studentDash.totalMentors")}
                    value={uniqueTeacherCount}
                  />
                  <StatCard
                    icon={StudentDas3}
                    label={t("adminDash.studentDash.sessionsCompleted")}
                    value={0}
                  />
                </div>
              </div>
            )}
          </div>

          {/* Secondary panel to balance layout visually */}
          {!loading && (
            <div className="mt-6 px-5">
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
                <div className="lg:col-span-2 rounded-2xl border bg-white p-4 shadow-sm">
                  <p className="text-lg font-semibold mb-2">{t("adminDash.studentDash.tips")}</p>
                  <ul className="text-sm text-gray-600 list-disc pl-5 space-y-1">
                    <li>{t("adminDash.studentDash.tip1")}</li>
                    <li>{t("adminDash.studentDash.tip2")}</li>
                    <li>{t("adminDash.studentDash.tip3")}</li>
                  </ul>
                </div>
                <div className="rounded-2xl p-4 shadow-sm border bg-gradient-to-br from-[#EE5F2B]/10 to-[#2A3A54]/10">
                  <p className="text-lg font-semibold mb-1">{t("adminDash.studentDash.quickActions")}</p>
                  <div className="flex flex-col gap-2 mt-2">
                    <Link
                      to="../mentee-tution"
                      className="px-3 py-2 rounded-xl text-white text-sm font-semibold text-center bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54] hover:from-[#2A3A54] hover:to-[#EE5F2B]"
                    >
                      {t("adminDash.studentDash.viewAllSessions")}
                    </Link>
                    <Link
                      to="../mentee-chat"
                      className="px-3 py-2 rounded-xl text-[#2A3A54] border border-[#2A3A54]/30 text-sm font-semibold text-center hover:bg-[#2A3A54]/5"
                    >
                      {t("adminDash.studentDash.messageMentor")}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default StudentDash;
